
export function stateIsProducerAdminAuthenticated(state) {
    if (state.auth.logged_in === false) {
        return false
    }
    return state.auth.user_is_producer_admin
}
